<section class="component-tab component-tab--press component-tab--two-column two-column entry-content">
	<div class="wrapper">
	<div class="row">
		<div class="col-12 tab-title__col">
			<h2 class="tab__title" *ngIf="twoColumnData.tccb_heading != ''" [innerHtml]="twoColumnData.tccb_heading"></h2>
		</div>
		<div class="col-12 col-sm-6">
			<div class="two-column__content" *ngFor="let lcVal of twoColumnData.left_column_content">
				<h4 *ngIf="lcVal.tccb_lcc_title != ''" [innerHtml]="lcVal.tccb_lcc_title"></h4>
				<div class="entry-content" [innerHtml]="lcVal.tccb_lcc_content | safe:'preamble'"></div>
			</div>
		</div>
		<div class="col-12 col-sm-6">
			<div class="two-column__content" *ngFor="let rcVal of twoColumnData.right_column_content">
				<h4 *ngIf="rcVal.tccb_rcc_title != ''" [innerHtml]="rcVal.tccb_rcc_title"></h4>
				<div class="entry-content" [innerHtml]="rcVal.tccb_rcc_content | safe:'preamble'"></div>
			</div>
		</div>
	</div>
	</div>
</section>